const DEVICE_ID_KEY = 'wizmage_device_id';

/**
 * Stable per-browser id sent as `X-Device-Id` on API calls. The backend
 * buckets SMS rate limits by device when present — without it, every user
 * behind one NAT with the same browser build shares a single send quota.
 * Returns '' when storage is unavailable, in which case the header is omitted.
 */
export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing) {
      return existing;
    }
    const id = createDeviceId();
    localStorage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    return '';
  }
}

function createDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
